import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

function Preparer() {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const isMobile = size.height > size.width;

  const handleWindowSizeChange = () => setSize({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}><Grid item xs={12}><Paper className="paperFull">Nous avons hate que ca marche su'a coche!</Paper></Grid></Grid>
    </Container>
  );
}

export default Preparer;



// WEBPACK FOOTER //
// src/components/Preparer.js